import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

export const fetchKeyPersonDetails = (customerId: number) => {
  const sessionId = getSessionId();
  const UidEmailRole = UidEmailRoleMatch();

  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.customer_key_person/`,
      {
        params: {
          ...UidEmailRole,
          filter: `[('customer_id', 'in',  [${customerId}])]`,
          query:
            "{id, customer_id,key_person_type_ids{lov_display_value},designation,if_others,partnership_percentage,first_name,middle_name,last_name,related_person_type,father_spouse_name,mother_name,gender,date_of_birth,ownership_percentage,tax_id,employee_id,passport_number,passport_expiry_date,nationality_country_id{name},tax_residency_country_id{name},email,ckycno,is_politically_exposed,is_minor,is_beneficial_owner,is_admin,guardian_relation,guardian_name,key_person_address_line_1,key_person_address_line_2,key_person_address_city,key_person_address_district,key_person_address_state,key_person_address_pincode,key_person_address_country_id{name},phone_country_code,phone,din,customer_key_person_document_ids,api_designation_flag,api_first_name_flag,api_last_name_flag,api_date_of_birth_flag,api_gender_flag,api_mother_name_flag,nationality_country_id_flag,api_tax_id_flag,api_din_flag,api_district_flag,api_state_flag,api_country_flag,api_city_flag,api_email_flag,api_if_others_flag, is_current_address, key_person_current_address_line_1, key_person_current_address_line_2, key_person_current_address_pincode,key_person_current_address_district,key_person_current_address_state,key_person_current_address_country_id{name}, key_person_current_address_city, key_person_vkyc_case_id, key_person_vkyc_live_case_url, key_person_vkyc_scheduled_time, key_person_vkyc_created_at, vkyc_address_changed, vkyc_pan_changed, vkyc_mobile_changed, vkyc_email_changed, vkyc_name_changed}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      },
    )
    .then((response) => {
      // console.warn("iid in api-->", customerId);
      return response;
    })
    .catch((err) => err);
};
